// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"151f0e291b20f53f59b2","9249":"6f9cfa2a29dbb08016c2"}[chunkId] + ".chunk.js";
};